import React, {FC} from 'react';
import './style.scss';
import mixer from '../../../assets/img/intro/intro__mixer.png'
import ItemMixerNow from "../ItemMixerNow";
import BaseButton from "../../form/Button";
import {useHistory} from 'react-router-dom';

interface IMixerNow {
    tobaccoList: Array<number>,
    getResultMixer: any,
    removeMix: any
}

const MixerNow: FC<IMixerNow> = ({
                                     tobaccoList,
                                     getResultMixer,
                                     removeMix
                                 }) => {
    const history = useHistory();
    return (
        <div className="mixer-now">
            <div className="mixer-now__container">
                <div className="mixer-now__wrapper">
                    <img
                        className="mixer-now__img"
                        src={mixer}
                        alt="Mixer"
                    />
                    <div className="mixer-now__title">
                        Сейчас в миксере:
                    </div>
                </div>
                <div className="mixer-now__list">
                    {
                        tobaccoList.map((item: any) => {
                            return (
                                <ItemMixerNow
                                    key={item.id}
                                    onClick={() => removeMix(item.id)}
                                    brandName={item.brandName}
                                    tobaccoName={item.name}
                                />
                            )
                        })
                    }
                </div>
                <div className="mixer-now__button-wrap">
                    <div className="mixer-now__find-button">
                        <BaseButton
                            isFullWidth
                            isGreenButton
                            sizeBorderRadius={10}
                            sizePadding="12px 0"
                            onClick={() => {
                                getResultMixer();
                                history.push("/mixer/result")
                            }}
                        >
                   <span className="mixer-now__button-text">
                        Найти миксы
                   </span>
                        </BaseButton>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default MixerNow;
